import React, { useEffect, useRef, useState } from "react";

/**
 * Renders a looping background video when the user has a good connection
 * and prefers motion. Falls back to a static image otherwise.
 */
const SmartBgVideo = ({
  src,
  poster,
  alt = "",
  className = "",
  imgClassName = "",
  videoClassName = "",
}) => {
  const [showVideo, setShowVideo] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    // Respect user preference: reduced motion
    const reduced = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    if (reduced) {
      setShowVideo(false);
      return;
    }
    // Detect connection quality (Network Information API)
    const conn =
      navigator.connection ||
      navigator.mozConnection ||
      navigator.webkitConnection;

    if (conn) {
      // Only skip video on explicitly slow connections or user-enabled data saver
      const slow =
        conn.saveData ||
        ["slow-2g", "2g", "3g"].includes(conn.effectiveType);
      setShowVideo(!slow);
    } else {
      // No connection API (Safari iOS, Firefox) — default to showing video
      setShowVideo(true);
    }
  }, []);

  return (
    <div className={className}>
      <img
        src={poster}
        alt={alt}
        className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${
          showVideo ? "opacity-0" : "opacity-100"
        } ${imgClassName}`}
      />
      {showVideo && (
        <video
          ref={ref}
          src={src}
          poster={poster}
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
          className={`absolute inset-0 w-full h-full object-cover ${videoClassName}`}
        />
      )}
    </div>
  );
};

export default SmartBgVideo;
